import React, { useEffect, useState } from "react";
import { useServiceProductsQuery } from "../../Store/Apis/servicesApi";
import {
  useCreateCustomerMutation,
  useCustomersQuery,
} from "../../Store/Apis/customerApi";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { DatePicker } from "antd";
import moment from "moment";
import { allCountries } from "country-telephone-data";
import Error from "../Error/Error";
import Loader from "../Loader/Loader";
import { useSelector } from "react-redux";
import AddPaymentForm from "../AddPaymentForm/AddPaymentForm";
import { useTaxPercentageQuery } from "../../Store/Apis/toolsApi";
import {
  useOrderByCustomerIdQuery,
  useOrderByIdQuery,
} from "../../Store/Apis/bookingApi";
import {
  fetchRoomTypes,
  checkRoomAvailability,
  getCompany,
  getClientsByPaymentType,
} from "../../Store/Apis/ReservationApi";
import { CiWarning } from "react-icons/ci";
import {
  FaCreditCard,
  FaTrash,
  FaPlus,
  FaMinus,
  FaWineBottle,
  FaBeer,
  FaCoffee,
  FaArrowLeft,
  FaUtensils,
  FaConciergeBell,
} from "react-icons/fa";
import { MdLocalBar, MdLiquor } from "react-icons/md";
import { RiBankCard2Fill } from "react-icons/ri";
import { GiMartini, GiWineGlass } from "react-icons/gi";
const ACCOMMODATION_TYPE_ID = 0; // TODO: replace with real ID when available from API
// Flexible accommodation detector with explicit flag support.
const isAccommodation = (s) => {
  if (!s) return false;
  if (s.accommodation) return true; // explicit flag when stored
  if (
    ACCOMMODATION_TYPE_ID &&
    Number(s.typeId) === Number(ACCOMMODATION_TYPE_ID)
  )
    return true;
  const n = (
    s.name ||
    s.typeName ||
    s.productServiceName ||
    s.rawName ||
    ""
  ).toLowerCase();
  if (!n) return false;
  if (n.includes("accom")) return true; // covers accommodation / accom.
  if (n.includes("room")) return true;
  // Common packages/labels that are accommodations even if they don't contain the word "room"
  if (n.includes("bed only") || n.includes("bed-only") || n.includes("bedonly"))
    return true;
  if (
    n.includes("room only") ||
    n.includes("room-only") ||
    n.includes("roomonly")
  )
    return true;
  const kwHits = ["bed", "breakfast", "dinner"].filter((k) =>
    n.includes(k),
  ).length;
  if (kwHits >= 2) return true; // composite meal + bed patterns
  return false;
};

const BarTender = ({ onSubmit, data, paymentData, isSubmitting }) => {
  // Helper placed inside component so it can access getNameKey defined later
  const getNameKey = (x) =>
    (
      x?.typeName ||
      x?.productServiceName ||
      x?.name ||
      x?.rawName ||
      x?.serviceName ||
      ""
    )
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");

  const dedupeGuestServices = (arr = []) => {
    const map = new Map();
    arr.forEach((s) => {
      const key = `${getNameKey(s)}::${Number(s.childId)}`;
      map.set(key, s);
    });
    return Array.from(map.values());
  };
  const user = useSelector((state) => state.auth.user);

  // --- Added missing state declarations ---
  const [roomTypes, setRoomTypes] = useState([]);
  const [loadingRoomTypes, setLoadingRoomTypes] = useState(false);
  const [checkInDate, setCheckInDate] = useState(null);
  const [checkOutDate, setCheckOutDate] = useState(null);
  const [availableRooms, setAvailableRooms] = useState([]);
  const [roomsAvailable, setRoomsAvailable] = useState(null);
  const [checkingAvailability, setCheckingAvailability] = useState(false);
  const [selectedRooms, setSelectedRooms] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [companySuggestions, setCompanySuggestions] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  // Track original item count to distinguish existing vs new items
  const [originalItemCount, setOriginalItemCount] = useState(0);
  // Snapshots of original services for diffing (edit mode)
  const [originalIndividualServices, setOriginalIndividualServices] = useState(
    [],
  ); // rooms + children flattened
  // Composite keys of original individual items to filter out on submit (avoid re-sending existing)
  const [originalIndividualKeyList, setOriginalIndividualKeyList] = useState(
    [],
  );
  const [originalCompanyServices, setOriginalCompanyServices] = useState([]); // flattened guest services
  // Snapshot of original company subCustomers (with their services) for diffing existing guest edits
  const [originalSubCustomers, setOriginalSubCustomers] = useState([]);

  // Customer type selection
  const [customerType, setCustomerType] = useState("individual");

  // Form fields for individual customer
  const [customerForm, setCustomerForm] = useState({
    salutation: "Mr",
    customerName: "",
    countryCode: "+27",
    phoneNumber: "",
    email: "",
    isCustomerSelected: false,
    customerID: null,
  });

  // Company booking state
  const [companyForm, setCompanyForm] = useState({
    companyName: "",
    companyID: null,
    companyAddress: "",
    companyContact: "",
    companyEmail: "", // added
    creditLimit: 0,
    currentLimit: 0,
    isCompanySelected: false,
  });

  // Sub-customers for company bookings
  const [subCustomers, setSubCustomers] = useState([]);
  // Active guest index for assigning services when company booking
  const [activeGuestIndex, setActiveGuestIndex] = useState(null);

  const [sortFilter, setSortFilter] = useState({
    productSearch: "",
    customerSearch: "",
    outletID: 4, // force outletID = 4
  });
  // Moved here so it's initialized before being used in dependencies
  const [filterType, setFilterType] = useState("All");

  // Category management state
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isInCategoryView, setIsInCategoryView] = useState(false);

  // Parent ID categories
  const drinkParentIds = [118,217, 278, 279, 280, 281];
  const serverParentId = 272;

  // Category icons mapping - for specific drink categories
  const categoryIcons = {
    "NON-ALCOHOLIC BEVERAGES": FaCoffee,
    SHOTS: GiMartini,
    "CIDERS/BEER": FaBeer,
    WINES: GiWineGlass,
  };

  // Function to get icon based on category name and parentId
  const getCategoryIcon = (categoryName, products) => {
    // Check if this category has items with serverParentId (272)
    const hasServerItems = products.some(
      (p) =>
        p.productServiceName === categoryName &&
        Number(p.parentId) === serverParentId,
    );
    if (hasServerItems) return FaConciergeBell;

    // Check if category has a specific drink icon
    if (categoryIcons[categoryName]) return categoryIcons[categoryName];

    // Check if this category contains drinks
    const hasDrinkItems = products.some(
      (p) =>
        p.productServiceName === categoryName &&
        drinkParentIds.includes(Number(p.parentId)),
    );
    if (hasDrinkItems) return MdLocalBar;

    // Default to food icon for everything else
    return FaUtensils;
  };

  // Service products query - removed keyname since we're filtering on frontend
  const serviceProductsApi = useServiceProductsQuery(
    {
      keyname: "", // Empty since we filter child items on frontend
      outletID: sortFilter.outletID,
      // Pass companyID when company booking else pass customerID (backend handles either)
      ...(customerType === "company" && companyForm.companyID
        ? { companyID: companyForm.companyID }
        : {}),
      ...(customerType !== "company" && customerForm.customerID
        ? { customerID: customerForm.customerID }
        : {}),
    },
    { skip: !sortFilter.outletID },
  );

  // Populate filteredProducts from API and filter child items based on search
  useEffect(() => {
    if (serviceProductsApi.isSuccess) {
      let items =
        serviceProductsApi.data?.data || serviceProductsApi.data || [];
      if (!Array.isArray(items)) items = [];

      // IDs to exclude from display
      const excludedParentIds = [251, 212, 77038, 290];
      items = items.filter(
        (item) => !excludedParentIds.includes(Number(item.parentId)),
      );

      // If there's a search term, filter across all categories and show matching items
      if (sortFilter.productSearch && sortFilter.productSearch.trim() !== "") {
        const searchTerm = sortFilter.productSearch.toLowerCase().trim();

        // Filter child items that match search term across all categories
        items = items
          .map((product) => ({
            ...product,
            childRecords: (product.childRecords || []).filter(
              (child) =>
                child.typeName?.toLowerCase().includes(searchTerm) ||
                child.description?.toLowerCase().includes(searchTerm) ||
                product.productServiceName?.toLowerCase().includes(searchTerm),
            ),
          }))
          .filter(
            (product) =>
              product.childRecords && product.childRecords.length > 0,
          );
      } else {
        // If no search term, apply category filter
        if (selectedCategory) {
          items = items.filter(
            (item) => item.productServiceName === selectedCategory,
          );
        }
      }

      // Remove filter type logic since we're not using it anymore
      // if (filterType === "Product") items = items.filter((p) => p.type === 1);
      // else if (filterType === "Service")
      //   items = items.filter((p) => p.type === 2);
      setFilteredProducts(items);
    } else if (serviceProductsApi.isError) {
      setFilteredProducts([]);
    }
  }, [
    serviceProductsApi.data,
    serviceProductsApi.isSuccess,
    serviceProductsApi.isError,
    sortFilter.productSearch,
    selectedCategory,
    // filterType, // Removed since we're not using filters anymore
  ]);

  // Initialize dates with current date for bar orders
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0]; // Format: YYYY-MM-DD
    if (!checkInDate) {
      setCheckInDate(today);
    }
    if (!checkOutDate) {
      setCheckOutDate(today);
    }
  }, []); // Run only once on mount

  // Customer search query
  const customerApi = useCustomersQuery(
    {
      keyword: customerForm.customerName,
      outletID: sortFilter.outletID,
    },
    { skip: !sortFilter.outletID || !customerForm.customerName },
  );

  // Initialize createCustomer mutation
  const [createCustomer, createCustomerResponse] = useCreateCustomerMutation();

  const [selectedChildren, setSelectedChildren] = useState([]);
  // Product details modal state (reintroduced)
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  // Staged selections inside the Product Details modal: { [childId]: quantity }
  const [modalSelections, setModalSelections] = useState({});
  // Bill-to-Account toggle
  const [isOnAccount, setIsOnAccount] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  // Modals
  const [paymentFormModal, setPaymentFormModal] = useState(false);
  // Credit limit confirmation modal
  const [limitModal, setLimitModal] = useState({
    show: false,
    reason: "",
    diff: 0,
    available: 0,
  });

  // Account on hold confirmation modal
  const [accountHoldModal, setAccountHoldModal] = useState({
    show: false,
    customerType: "",
    customerName: "",
  });

  // Add to Tab functionality state
  const [showTabSearchModal, setShowTabSearchModal] = useState(false);
  const [tabSearchTerm, setTabSearchTerm] = useState("");
  const [tabClients, setTabClients] = useState([]);
  const [selectedTabClient, setSelectedTabClient] = useState(null);
  const [loadingTabClients, setLoadingTabClients] = useState(false);
  // Tab quotation state
  const [tabCreateQuotation, setTabCreateQuotation] = useState(false);
  const [showTabEmailModal, setShowTabEmailModal] = useState(false);
  const [tabQuotationEmail, setTabQuotationEmail] = useState("");
  const [tabCcEmail, setTabCcEmail] = useState("");
  const [tabDocSendType, setTabDocSendType] = useState("proforma");

  // Build initial staged selections for the modal based on current selections

  const buildInitialModalSelections = (product) => {
    const next = {};
    const children = product?.childRecords || [];
    const idsOf = (obj) =>
      [
        obj?.childId,
        obj?.serviceId,
        obj?.serviceID,
        obj?.serviceTypeId,
        obj?.typeId,
      ]
        .filter((v) => v !== undefined && v !== null)
        .map((v) => v.toString());
    const childMatches = (child, item) => {
      const cids = idsOf(child);
      const iids = idsOf(item || {});
      return cids.some((id) => iids.includes(id));
    };
    if (customerType === "company") {
      if (activeGuestIndex === null) return next;
      const guest = subCustomers[activeGuestIndex] || {};
      const current = guest.services || [];
      children.forEach((child) => {
        const found = current.find((s) => childMatches(child, s));
        if (found) next[child.childId] = found.quantity || 1;
      });
    } else {
      children.forEach((child) => {
        const fromChildren = selectedChildren.find((c) =>
          childMatches(child, c),
        );
        const fromRooms = selectedRooms.find((r) => childMatches(child, r));
        const picked = fromChildren || fromRooms;
        if (picked) next[child.childId] = picked.quantity || 1;
      });
    }
    return next;
  };

  // Open Product modal (staged selection; commit on Confirm)
  const handleSelectProduct = (product) => {
    if (customerType === "company" && activeGuestIndex === null) {
      toast.error("Select a guest card first");
      return;
    }
    setSelectedProduct(product);
    setModalSelections(buildInitialModalSelections(product));
    setIsProductModalOpen(true);
  };

  // Child selection toggle (individual vs company guest assignment)
  const handleSelectChild = (child) => {
    if (customerType === "company") {
      if (activeGuestIndex === null) {
        toast.error("Select a guest card first");
        return;
      }
      setSubCustomers((prev) => {
        const copy = [...prev];
        const guest = copy[activeGuestIndex];
        const exists = guest.services.some(
          (s) => Number(s.childId) === Number(child.childId),
        );
        if (exists) {
          guest.services = guest.services.filter(
            (s) => Number(s.childId) !== Number(child.childId),
          );
        } else {
          const rawName = child.typeName || child.productServiceName || "";
          const accommodationFlag = isAccommodation(child);
          guest.services.push({
            childId: child.childId,
            rate: child.rate,
            quantity: 1,
            typeId: child.typeId,
            name: rawName,
            rawName,
            accommodation: accommodationFlag,
            parentId: child.parentId || 0,
          });
        }
        copy[activeGuestIndex] = { ...guest };
        return copy;
      });
    } else {
      const cid = Number(child.childId);
      const tid = Number(child.typeId);
      const pid = Number(child.parentId);
      // Route accommodations to selectedRooms to avoid cross-list duplicates
      if (isAccommodation(child)) {
        setSelectedRooms((prev) => {
          const exists = prev.some((it) => Number(it.childId) === cid);
          if (exists) return prev.filter((it) => Number(it.childId) !== cid);
          // Also remove from children if present
          setSelectedChildren((pc) =>
            pc.filter((c) => Number(c.childId) !== cid),
          );
          return [
            ...prev,
            {
              childId: cid,
              typeId: tid,
              parentId: pid,
              typeName: child.typeName,
              rate: Number(child.rate),
              quantity: 1,
              maxQuantity: child.quantity,
            },
          ];
        });
      } else {
        setSelectedChildren((prev) => {
          const exists = prev.some((item) => Number(item.childId) === cid);
          if (exists)
            return prev.filter((item) => Number(item.childId) !== cid);
          // Also remove from rooms if present
          setSelectedRooms((pr) => pr.filter((r) => Number(r.childId) !== cid));
          return [
            ...prev,
            {
              ...child,
              quantity: 1,
              rate: Number(child.rate),
              maxQuantity: child.quantity,
            },
          ];
        });
      }
    }
  };

  // Quantity change for selected child (from modal or summary table)
  const handleQuantityChange = (child, type) => {
    if (customerType === "company") {
      if (activeGuestIndex === null) return;
      setSubCustomers((prev) => {
        const copy = [...prev];
        const guest = copy[activeGuestIndex];
        guest.services = guest.services.map((s) => {
          if (s.childId !== child.childId) return s;
          let q = s.quantity || 1;
          if (type === "increment") q++;
          else if (type === "decrement") q--;
          if (q < 1) q = 1;
          return { ...s, quantity: q };
        });
        copy[activeGuestIndex] = { ...guest };
        return copy;
      });
    } else {
      setSelectedChildren((prev) =>
        prev
          .map((item) => {
            if (item.childId !== child.childId) return item;
            let q = item.quantity || 1;
            if (type === "increment") q = q + 1;
            else if (type === "decrement") q = q - 1;
            return { ...item, quantity: q };
          })
          .filter((item) => item.quantity > 0),
      );
    }
  };

  // Remove ability to change rate once selected (function retained if needed elsewhere)
  const handleRateChange = () => {};

  // --- Per-guest services helpers (added) ---
  function calculateNights(checkIn, checkOut) {
    if (!checkIn || !checkOut) return 0;
    const start = moment(checkIn);
    const end = moment(checkOut);
    const diff = end.diff(start, "days");
    // treat same-day check-in/out as 1 night, never less than 1 if both provided
    return diff > 0 ? diff : 1;
  }

  function guestTotal(guest) {
    if (!guest || !guest.services) return 0;
    const nights = calculateNights(
      guest.customerCheckIn,
      guest.customerCheckOut,
    );
    return guest.services.reduce((sum, s) => {
      if (isAccommodation(s)) {
        return sum + (s.rate || 0) * (s.quantity || 1) * nights;
      }
      return sum + (s.rate || 0) * (s.quantity || 1);
    }, 0);
  }

  // Derive roomID for a company guest from its accommodation service or stored field
  const deriveRoomId = (guest) => {
    if (!guest) return 0;
    if (guest.roomID || guest.roomId)
      return Number(guest.roomID || guest.roomId || 0);
    const services = guest.services || [];
    // Prefer accommodation service room id
    const acc = services.find(
      (s) => isAccommodation(s) && (s.roomID || s.roomId),
    );
    if (acc) return Number(acc.roomID || acc.roomId || 0);
    // Fallback: any service that has a room id
    const anyWith = services.find((s) => s.roomID || s.roomId);
    if (anyWith) return Number(anyWith.roomID || anyWith.roomId || 0);
    return 0;
  };

  // Back-fill roomID onto subCustomers after hydration if available in services
  useEffect(() => {
    if (customerType !== "company" || subCustomers.length === 0) return;
    // Only update if at least one guest lacks roomID but has an accommodation service with one
    let needsUpdate = false;
    const next = subCustomers.map((g) => {
      if (g.roomID || g.roomId) return g;
      const acc = (g.services || []).find(
        (s) => isAccommodation(s) && (s.roomID || s.roomId),
      );
      if (acc) {
        needsUpdate = true;
        return { ...g, roomID: acc.roomID || acc.roomId };
      }
      return g;
    });
    if (needsUpdate) setSubCustomers(next);
  }, [customerType, subCustomers]);

  const handleServiceSelectForGuest = (guestIndex, service) => {
    setSubCustomers((prev) => {
      const copy = [...prev];
      const guest = copy[guestIndex];
      if (!guest.services) guest.services = [];
      const exists = guest.services.some((s) => s.childId === service.childId);
      if (exists) {
        guest.services = guest.services.filter(
          (s) => s.childId !== service.childId,
        );
      } else {
        const rawName = service.productServiceName || service.typeName || "";
        const accommodationFlag = isAccommodation(service);
        guest.services.push({
          childId: service.childId,
          rate: service.rate,
          quantity: 1,
          typeId: service.typeId,
          name: rawName,
          rawName,
          accommodation: accommodationFlag,
          parentId: service.parentId || 0,
        });
      }
      copy[guestIndex] = { ...guest };
      return copy;
    });
  };

  const updateGuestServiceQuantity = (guestIndex, childId, newQty) => {
    if (newQty <= 0) newQty = 1;
    setSubCustomers((prev) => {
      const copy = [...prev];
      const guest = copy[guestIndex];
      guest.services = guest.services.map((s) =>
        s.childId === childId ? { ...s, quantity: newQty } : s,
      );
      copy[guestIndex] = { ...guest };
      return copy;
    });
  };

  // Recompute subtotal including both rooms and selected children or per-guest totals.
  // For individual bookings, multiply accommodation lines by number of nights.
  const subtotal = (() => {
    if (customerType === "company") {
      return subCustomers.reduce((acc, sub) => acc + guestTotal(sub), 0);
    }

    const nightsVal = (() => {
      const n = calculateNights(checkInDate, checkOutDate);
      return n > 0 ? n : 1; // default 1 until dates chosen
    })();

    const total = [...selectedRooms, ...selectedChildren].reduce(
      (acc, item) => {
        const base = (item.rate || 0) * (item.quantity || 1);
        return acc + (isAccommodation(item) ? base * nightsVal : base);
      },
      0,
    );

    // Debug log to see what's in the arrays
    console.log("Subtotal calculation debug:", {
      selectedRoomsCount: selectedRooms.length,
      selectedChildrenCount: selectedChildren.length,
      total: total,
      items: [...selectedRooms, ...selectedChildren].map((item) => ({
        name: item.typeName || item.productServiceName,
        rate: item.rate,
        quantity: item.quantity,
        childId: item.childId,
      })),
    });

    return total;
  })();

  useEffect(() => {
    if (user.outletID) loadRoomTypes();
  }, [user.outletID]);

  const loadRoomTypes = async () => {
    setLoadingRoomTypes(true);
    try {
      const rooms = await fetchRoomTypes(user.outletID);
      setRoomTypes(rooms || []);
    } catch (e) {
      toast.error("Failed to load room types");
    } finally {
      setLoadingRoomTypes(false);
    }
  };

  useEffect(() => {
    if (checkInDate && checkOutDate && checkInDate < checkOutDate)
      checkAvailability();
  }, [checkInDate, checkOutDate]);

  const checkAvailability = async () => {
    setCheckingAvailability(true);
    try {
      const availability = await checkRoomAvailability(
        checkInDate,
        checkOutDate,
        4,
      ); // force outletID=4
      setAvailableRooms(availability || []);
      setRoomsAvailable(Array.isArray(availability) && availability.length > 0);
    } catch (e) {
      setRoomsAvailable(false);
      toast.error("Failed to check room availability");
    } finally {
      setCheckingAvailability(false);
    }
  };

  const handleCustomerTypeChange = (type) => {
    setCustomerType(type);
    setCustomerForm({
      salutation: "Mr",
      customerName: "",
      countryCode: "+27",
      phoneNumber: "",
      email: "",
      isCustomerSelected: false,
      customerID: null,
    });
    setCompanyForm({
      companyName: "",
      companyID: null,
      companyAddress: "",
      companyContact: "",
      companyEmail: "",
      creditLimit: 0,
      currentLimit: 0,
      isCompanySelected: false,
    });
    setSubCustomers([]);
    setShowSuggestions(false);
    setIsOnAccount(false);
  };

  const handleCustomerFormChange = (e) => {
    const { name, value } = e.target;
    setCustomerForm((prev) => ({
      ...prev,
      [name]: value,
      isCustomerSelected: false,
    }));
    if (name === "customerName") setShowSuggestions(value.trim().length > 0);
  };

  const handleCompanyFormChange = async (e) => {
    const { name, value } = e.target;
    setCompanyForm((prev) => ({
      ...prev,
      [name]: value,
      isCompanySelected: false,
    }));
    if (name === "companyName" && value.trim().length > 1) {
      try {
        const companies = await getCompany({
          companyName: value,
          outletID: user.outletID,
        }); // correct param casing
        setCompanySuggestions(companies || []);
      } catch (err) {
        console.error("Error fetching companies", err);
      }
    } else if (name === "companyName" && value.trim().length === 0) {
      setCompanySuggestions([]);
    }
  };

  const handleCustomerSelect = (customer) => {
    // Debug: Log the customer data to see what creditAccStatus we're getting
    console.log("Selected customer data:", customer);
    console.log("creditAccStatus:", customer?.creditAccStatus);

    setSelectedCustomer(customer); // Store the full customer object with all fields including creditAccStatus
    setCustomerForm((prev) => ({
      ...prev,
      customerName: customer.customerName,
      customerID: customer.customerID,
      phoneNumber: customer.phoneNumber || customer.phone || "",
      email: customer.email || "",
      salutation: customer.salutation || "Mr",
      countryCode: customer.countryCode || "+27",
      isCustomerSelected: true,
    }));
    setShowSuggestions(false);
  };

  const handleCompanySelect = (company) => {
    setCompanyForm((prev) => ({
      ...prev,
      companyName: company.companyName,
      companyID: company.companyID,
      companyAddress:
        company.companyAddress ||
        company.companyaddress ||
        company.company_Address ||
        company.address ||
        "",
      companyContact:
        company.companyPhoneNumber ||
        company.companyContact ||
        company.phoneNumber ||
        "",
      companyEmail:
        company.companyEmailAddress ||
        company.companyEmail ||
        company.email ||
        "",
      creditLimit:
        company.limit ??
        company.creditLimit ??
        company.credit_Limit ??
        company.credit_limit ??
        0,
      currentLimit:
        company.currentLimit ??
        company.current_Limit ??
        company.availableLimit ??
        0,
      creditAccStatus: company.creditAccStatus, // Preserve credit account status
      isCompanySelected: true,
    }));
    setCompanySuggestions([]);
  };

  const addSubCustomer = () => {
    setSubCustomers((prev) => [
      ...prev,
      {
        customerName: "",
        customerEmail: "",
        customerCheckIn: null,
        customerCheckOut: null,
        availability: null,
        services: [], // per-guest selected services
      },
    ]);
    setActiveGuestIndex((prev) =>
      prev === null
        ? 0
        : prev + 1 === subCustomers.length + 1
          ? prev + 1
          : prev,
    );
  };
  // Remove a sub customer by index
  const removeSubCustomer = (index) => {
    setSubCustomers((prev) => prev.filter((_, i) => i !== index));
  };
  const updateSubCustomer = (index, field, value) => {
    setSubCustomers((prev) => {
      const copy = [...prev];
      copy[index][field] = value;
      // Reset availability if date fields changed
      if (field === "customerCheckIn" || field === "customerCheckOut") {
        const sc = copy[index];
        if (
          sc.customerCheckIn &&
          sc.customerCheckOut &&
          sc.customerCheckIn < sc.customerCheckOut
        ) {
          // trigger availability check per guest
          checkGuestAvailability(
            index,
            sc.customerCheckIn,
            sc.customerCheckOut,
          );
        } else {
          copy[index].availability = null;
        }
      }
      return copy;
    });
  };

  const checkGuestAvailability = async (idx, start, end) => {
    setSubCustomers((prev) =>
      prev.map((g, i) => (i === idx ? { ...g, availability: "checking" } : g)),
    );
    try {
      const availability = await checkRoomAvailability(start, end, 3);
      const available = Array.isArray(availability) && availability.length > 0;
      setSubCustomers((prev) =>
        prev.map((g, i) =>
          i === idx
            ? { ...g, availability: available ? "available" : "unavailable" }
            : g,
        ),
      );
    } catch (e) {
      setSubCustomers((prev) =>
        prev.map((g, i) => (i === idx ? { ...g, availability: "error" } : g)),
      );
    }
  };

  // Submit order: build payload and pass to parent
  const submitOrder = async (paymentData, statusId) => {
    console.log("[submitOrder] statusId param=", statusId);

    console.log("Payment data received in submitOrder:", {
      paymentDataSubtotal: paymentData.subtotal,
      localSubtotal: subtotal,
      grossTotal: paymentData.grossTotal,
      paidAmount: paymentData.paidAmount,
      discountAmount: paymentData.discountAmount,
    });

    console.log("Items in state when submitting:", {
      selectedRoomsCount: selectedRooms.length,
      selectedChildrenCount: selectedChildren.length,
      selectedRooms: selectedRooms.map((r) => ({
        name: r.typeName,
        rate: r.rate,
        quantity: r.quantity,
        childId: r.childId,
      })),
      selectedChildren: selectedChildren.map((c) => ({
        name: c.typeName || c.productServiceName,
        rate: c.rate,
        quantity: c.quantity,
        childId: c.childId,
      })),
    });

    // Create customer first if it's a new individual customer
    let finalCustomerID = customerForm.customerID;
    if (
      customerType === "individual" &&
      (!customerForm.customerID || customerForm.customerID === 0) &&
      customerForm.customerName &&
      customerForm.phoneNumber
    ) {
      try {
        const customerBody = {
          salutation: customerForm.salutation,
          name: customerForm.customerName,
          dateOfBirth: "", // Not captured in current form, but required by API
          email: customerForm.email,
          clientType: customerType,
          countryCode: customerForm.countryCode,
          customerRating: 0,
          phone: customerForm.phoneNumber,
          taxNumber: "",
          locality: "",
          pin: "",
          address: "",
          isActive: 1,
          OutletID: sortFilter.outletID,
        };

        console.log("Creating new customer:", customerBody);
        const customerResponse = await createCustomer(customerBody).unwrap();

        if (customerResponse?.status === 200) {
          finalCustomerID = customerResponse.data.customerID;
          console.log("New customer created with ID:", finalCustomerID);
          toast.success("New customer created successfully");
        } else {
          toast.error(customerResponse?.message || "Failed to create customer");
          return; // Don't proceed with booking if customer creation fails
        }
      } catch (error) {
        console.error("Customer creation failed:", error);
        toast.error("Failed to create customer. Please try again.");
        return; // Don't proceed with booking if customer creation fails
      }
    }

    let overallCheckIn = checkInDate;
    let overallCheckOut = checkOutDate;
    if (customerType === "company" && subCustomers.length > 0) {
      const validDates = subCustomers.filter(
        (s) => s.customerCheckIn && s.customerCheckOut,
      );
      if (validDates.length > 0) {
        overallCheckIn = validDates.reduce(
          (min, s) =>
            !min || s.customerCheckIn < min ? s.customerCheckIn : min,
          null,
        );
        overallCheckOut = validDates.reduce(
          (max, s) =>
            !max || s.customerCheckOut > max ? s.customerCheckOut : max,
          null,
        );
      }
    }
    // Build a working snapshot (avoid async state change before payload)
    const workingSubCustomers =
      customerType === "company"
        ? subCustomers.map((g) => ({
            ...g,
            services: dedupeGuestServices(g.services),
          }))
        : subCustomers;
    const allServices = buildServiceDetails();
    const isQuotation = statusId === 11;
    const billToAccount =
      !isQuotation && (paymentData?.billToAccount === true || isOnAccount);
    const orderBody = {
      customerName:
        customerType === "individual"
          ? customerForm.customerName
          : companyForm.companyName,
      customerID:
        paymentData.clientType === "individual" ||
        paymentData.clientType === "Customer"
          ? paymentData.clientID || finalCustomerID || 0
          : customerType === "individual"
            ? finalCustomerID || 0
            : 0,
      categoryID: user.serviceCategoryId || 0,
      companyID:
        paymentData.clientType === "company" ||
        paymentData.clientType === "Company"
          ? paymentData.clientID || 0
          : customerType === "company"
            ? companyForm.companyID || 0
            : 0,
      companyAddress:
        customerType === "company" ? companyForm.companyAddress : "",
      subCustomers:
        customerType === "company"
          ? (() => {
              const isEditing = Boolean(data && (data.orderID || data.orderId));
              if (!isEditing) {
                // Create mode: send all guests
                console.log(
                  "=== BUILDING SUBCUSTOMERS PAYLOAD (CREATE MODE) ===",
                );
                console.log("workingSubCustomers:", workingSubCustomers);

                return workingSubCustomers.map((sub) => {
                  console.log("Processing subcustomer (create):", sub);
                  console.log("customerID from sub:", sub.customerID);

                  return {
                    customerID: sub.customerID || 0, // ⭐ FIX: Include customerID for new subcustomers (0 for new)
                    roomId: deriveRoomId(sub),
                    roomID: deriveRoomId(sub),
                    companyID: companyForm.companyID || 0,
                    customerName: sub.customerName,
                    orderID: 0,
                    customerEmail: sub.customerEmail,
                    customerCheckIn: sub.customerCheckIn,
                    customerCheckOut: sub.customerCheckOut,
                    services: sub.services || [],
                    totalAmount: guestTotal(sub),
                  };
                });
              }
              // Editing an existing reservation
              const originalLen = originalSubCustomers.length;
              const toKey = (s) => `${Number(s.childId)}|${Number(s.typeId)}`;
              const existingGuestEdited = workingSubCustomers.some((g, idx) => {
                if (idx >= originalLen) return false; // new guest, ignore for edit detection
                const orig = originalSubCustomers[idx];
                if (!orig) return false;
                if (
                  orig.customerName !== g.customerName ||
                  orig.customerEmail !== g.customerEmail ||
                  orig.customerCheckIn !== g.customerCheckIn ||
                  orig.customerCheckOut !== g.customerCheckOut
                )
                  return true;
                const oServices = orig.services || [];
                const cServices = g.services || [];
                if (oServices.length !== cServices.length) return true;
                const oMap = new Map(oServices.map((s) => [toKey(s), s]));
                for (const cs of cServices) {
                  const os = oMap.get(toKey(cs));
                  if (!os) return true; // new service line inside existing guest
                  if (
                    Number(os.quantity) !== Number(cs.quantity) ||
                    Number(os.rate) !== Number(cs.rate)
                  )
                    return true; // modified values
                }
                return false;
              });

              if (!existingGuestEdited) {
                // Only additions (new rooms/guests) -> send only new ones (preserve previous behaviour)
                console.log(
                  "=== BUILDING SUBCUSTOMERS PAYLOAD (NEW GUESTS ONLY) ===",
                );
                const newGuests = workingSubCustomers.filter(
                  (_, idx) => idx >= originalLen,
                );
                console.log("newGuests:", newGuests);

                return newGuests.map((sub) => {
                  console.log("Processing new subcustomer:", sub);
                  console.log("customerID from sub:", sub.customerID);

                  return {
                    customerID: sub.customerID || 0, // ⭐ FIX: Include customerID for new guests (should be 0)
                    roomId: deriveRoomId(sub),
                    roomID: deriveRoomId(sub),
                    companyID: companyForm.companyID || 0,
                    customerName: sub.customerName,
                    orderID: 0,
                    customerEmail: sub.customerEmail,
                    customerCheckIn: sub.customerCheckIn,
                    customerCheckOut: sub.customerCheckOut,
                    services: sub.services || [],
                    totalAmount: guestTotal(sub),
                  };
                });
              }
              // Existing guest edited -> send full current list so backend diffs everything
              console.log("=== BUILDING SUBCUSTOMERS PAYLOAD (FULL LIST) ===");
              console.log("workingSubCustomers:", workingSubCustomers);

              return workingSubCustomers.map((sub) => {
                console.log("Processing subcustomer:", sub);
                console.log("customerID from sub:", sub.customerID);

                return {
                  customerID: sub.customerID || 0, // ⭐ FIX: Include customerID for existing subcustomers!
                  roomId: deriveRoomId(sub),
                  roomID: deriveRoomId(sub),
                  companyID: companyForm.companyID || 0,
                  customerName: sub.customerName,
                  orderID: 0,
                  customerEmail: sub.customerEmail,
                  customerCheckIn: sub.customerCheckIn,
                  customerCheckOut: sub.customerCheckOut,
                  services: sub.services || [],
                  totalAmount: guestTotal(sub),
                };
              });
            })()
          : [],
      orderID: 0,
      createdBy: user.id,
      clientType: paymentData.clientType || customerType,
      subTotal: subtotal,
      outletId: 4,
      statusId: statusId,
      checkInDate: overallCheckIn,
      checkOutDate: overallCheckOut,
      phoneNumber:
        customerType === "individual" ? customerForm.phoneNumber : "",
      email:
        paymentData.customerEmail ||
        (customerType === "individual"
          ? customerForm.email
          : companyForm.companyEmail || ""),
      // Include additional customer details for new customers
      salutation: customerType === "individual" ? customerForm.salutation : "",
      countryCode:
        customerType === "individual" ? customerForm.countryCode : "",
      optionalEmail: statusId === 11 ? paymentData.quotationEmail || "" : "",
      ccEmail: statusId === 11 ? paymentData.ccEmail || "" : "",
      BookingType: paymentData.documentType || "Proforma",
      discount: Number(paymentData.discount || 0),
      discountType: Number(paymentData.discountType || 0),
      paymentDate: new Date().toISOString(),
      // Quotation: no charges; On-account: no payment amount (they owe it); else normal
      receivedAmount: isQuotation
        ? 0
        : billToAccount
          ? 0
          : Number(paymentData.paidAmount || 0),
      payAmount: isQuotation ? 0 : billToAccount ? 0 : 0,
      paymentType: Number(
        paymentData.paymentType !== undefined
          ? paymentData.paymentType
          : billToAccount
            ? 4
            : 0,
      ),
      paymentNote: paymentData.notes || "",
      transactionId: "",
      utrNumber: paymentData.utrNumber || "",
      financialYearId: 0,
      isDeleted: 0,
      payNow: isQuotation
        ? 0
        : billToAccount
          ? 0
          : Number(paymentData.paidAmount || 0) > 0
            ? 1
            : 0,
      roomQuantity: [...selectedRooms, ...selectedChildren].reduce(
        (acc, item) => acc + (item.quantity || 0),
        0,
      ),
      serviceDetails: allServices,
      // Exceed limit flag required by backend ("yes" when limit exceeded)
      Exceed_Limit:
        paymentData?.exceedLimitFlag === true ||
        paymentData?.Exceed_Limit === "yes"
          ? "yes"
          : "no",
    };

    // === DEBUGGING UPDATE RESERVATION ===
    // console.log("=== DEBUGGING UPDATE RESERVATION ===");
    // console.log("originalItemCount:", originalItemCount);
    // console.log("subCustomers.length:", subCustomers.length);
    // console.log("subCustomers being sent:", subCustomers);
    // console.log("serviceDetails being sent:", allServices);
    // console.log(
    //   "serviceDetails detailed structure:",
    //   allServices.map((s) => ({
    //     serviceID: s.serviceID,
    //     typeID: s.typeID,
    //     parentID: s.parentID,
    //     roomID: s.roomID,
    //     keyID: s.keyID,
    //     orderDetailPrimaryID: s.orderDetailPrimaryID,
    //     serviceQuantity: s.serviceQuantity,
    //     serviceRate: s.serviceRate,
    //     detailPrice: s.detailPrice,
    //     nights: s.nights,
    //   }))
    // );
    // console.log("isEditing:", Boolean(data && (data.orderID || data.orderId)));
    // console.log("all subCustomers:", subCustomers);
    // console.log(
    //   "orderBody.subCustomers (final mapped):",
    //   JSON.parse(JSON.stringify(orderBody.subCustomers))
    // );
    // console.log("orderBody:", orderBody);
    // console.log("=====================================");

    await onSubmit(orderBody);
  };

  // Fix Save & Continue logic for company bookings
  const isFormValid = () => {
    const hasServices =
      customerType === "company"
        ? subCustomers.some((sc) => sc.services && sc.services.length > 0)
        : selectedRooms.length > 0 || selectedChildren.length > 0;
    if (customerType === "individual") {
      const basicValidation =
        customerForm.customerName &&
        customerForm.phoneNumber &&
        checkInDate &&
        checkOutDate &&
        hasServices;

      // If this is a new customer (no customerID), recommend having email for better record keeping
      const isNewCustomer =
        !customerForm.customerID || customerForm.customerID === 0;
      if (isNewCustomer && !customerForm.email) {
        console.log(
          "Email recommended for new customer - validation passed but form may show warning",
        );
      }

      return basicValidation;
    }
    const validSubs =
      subCustomers.length > 0 &&
      subCustomers.every(
        (s) =>
          s.customerName &&
          s.customerCheckIn &&
          s.customerCheckOut &&
          s.customerCheckIn < s.customerCheckOut &&
          s.availability !== "unavailable" &&
          s.availability !== "error",
      );
    return companyForm.companyName && hasServices && validSubs;
  };

  // Payment form submit
  const handlePaymentSubmit = (paymentData) => {
    setStoredPaymentData(paymentData);
    // Normal (non account) bookings never exceed limit flag
    submitOrder({ ...paymentData, exceedLimitFlag: false }, 12); // bar tender reservation status 12
  };

  const [storedPaymentData, setStoredPaymentData] = useState(null);
  const getStoredPaymentData = () => storedPaymentData;

  // Search for tab clients with Account Payment type (assuming payment type ID 4 for Account Payment)
  const searchTabClients = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
      setTabClients([]);
      return;
    }

    setLoadingTabClients(true);
    try {
      // First get clients by payment type (Account Payment - assuming ID 4)
      const response = await getClientsByPaymentType(4, 4);

      if (response.status === 200 && response.data) {
        let clients = Array.isArray(response.data) ? response.data : [];

        // Filter clients based on search term (comprehensive search)
        const filtered = clients.filter((client) => {
          const searchLower = searchTerm.toLowerCase();
          return (
            client.name?.toLowerCase().includes(searchLower) ||
            client.email?.toLowerCase().includes(searchLower) ||
            client.phone?.toString().includes(searchTerm) ||
            client.address?.toLowerCase().includes(searchLower) ||
            client.clientID?.toString().includes(searchTerm)
          );
        });

        setTabClients(filtered);
      } else {
        setTabClients([]);
        toast.error("Failed to fetch tab clients");
      }
    } catch (error) {
      console.error("Error searching tab clients:", error);
      setTabClients([]);
      toast.error("Error searching tab clients");
    } finally {
      setLoadingTabClients(false);
    }
  };

  // Handle tab client search with debounce
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      searchTabClients(tabSearchTerm);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [tabSearchTerm]);

  // Handle adding items to tab
  const handleAddToTab = () => {
    setShowTabSearchModal(true);
    setTabSearchTerm("");
    setTabClients([]);
    setSelectedTabClient(null);
    setTabCreateQuotation(false);
  };

  // Handle tab client selection
  const handleTabClientSelect = (client) => {
    setSelectedTabClient(client);
  };

  // Process tab payment
  const handleTabPayment = async () => {
    if (!selectedTabClient) {
      toast.error("Please select a client");
      return;
    }

    if (selectedChildren.length === 0) {
      toast.error("No items to add to tab");
      return;
    }

    // Check if client account is on hold
    if (selectedTabClient.creditAccStatus?.toLowerCase() === "on hold") {
      setAccountHoldModal({
        show: true,
        customerType: "Customer",
        customerName: selectedTabClient.name,
      });
      setShowTabSearchModal(false);
      return;
    }

    // Check credit limit (if currentLimit exists, otherwise proceed)
    const totalAmount = selectedChildren.reduce(
      (sum, item) => sum + item.quantity * item.rate,
      0,
    );

    if (
      selectedTabClient.currentLimit !== undefined &&
      selectedTabClient.currentLimit < totalAmount
    ) {
      setLimitModal({
        show: true,
        reason: `Insufficient credit limit. Available: R${
          selectedTabClient.currentLimit?.toFixed(2) || 0
        }, Required: R${totalAmount.toFixed(2)}`,
        diff: totalAmount - (selectedTabClient.currentLimit || 0),
        available: selectedTabClient.currentLimit || 0,
      });
      setShowTabSearchModal(false);
      return;
    }

    // Set customer form data for tab payment
    setCustomerType("individual"); // Ensure customer type is set to individual for tab payments
    setCustomerForm({
      salutation: "Mr",
      customerName: selectedTabClient.name,
      countryCode: "+27",
      phoneNumber: selectedTabClient.phone || "",
      email: selectedTabClient.email || "",
      isCustomerSelected: true,
      customerID: selectedTabClient.clientID,
    });

    setSelectedCustomer({
      customerID: selectedTabClient.clientID,
      customerName: selectedTabClient.name,
      phoneNumber: selectedTabClient.phone || "",
      email: selectedTabClient.email || "",
    });

    // If quotation is requested, open email modal instead of processing immediately
    if (tabCreateQuotation) {
      // Set customer form data first (needed for submitOrder later)
      setCustomerType("individual");
      setCustomerForm({
        salutation: "Mr",
        customerName: selectedTabClient.name,
        countryCode: "+27",
        phoneNumber: selectedTabClient.phone || "",
        email: selectedTabClient.email || "",
        isCustomerSelected: true,
        customerID: selectedTabClient.clientID,
      });
      setSelectedCustomer({
        customerID: selectedTabClient.clientID,
        customerName: selectedTabClient.name,
        phoneNumber: selectedTabClient.phone || "",
        email: selectedTabClient.email || "",
      });
      // Pre-fill quotation email with client email
      setTabQuotationEmail(selectedTabClient.email || "");
      setTabCcEmail("");
      setTabDocSendType("proforma");
      setShowTabSearchModal(false);
      setShowTabEmailModal(true);
      return;
    }

    // Process payment automatically (no payment modal needed for tab)
    const paymentData = {
      paymentType: 4, // Account Payment type ID
      amount: totalAmount,
      subtotal: totalAmount,
      grossTotal: totalAmount,
      paidAmount: 0, // For account payment, paidAmount should be 0
      discountAmount: 0,
      billToAccount: true,
      customerID: selectedTabClient.clientID,
      customerName: selectedTabClient.name,
      customerEmail: selectedTabClient.email || "", // Include email for tab payment
      clientType:
        selectedTabClient.clientType === "Customer"
          ? "individual"
          : selectedTabClient.clientType?.toLowerCase() || "individual", // Convert Customer to individual
      clientID: selectedTabClient.clientID, // Include clientID
      discount: 0,
      discountType: 0,
      taxAmount: 0,
      taxPercentage: 0,
      utrNumber: "",
      notes: "Added to tab via Bar Tender",
      exceedLimitFlag: false, // For tab payments, we already checked limit above
      Exceed_Limit: "no", // Explicitly set to "no" since we validated credit limit
    };

    try {
      setLoading(true);

      // Ensure dates are set for bar orders (use today's date)
      const today = new Date().toISOString().split("T")[0];
      if (!checkInDate) setCheckInDate(today);
      if (!checkOutDate) setCheckOutDate(today);

      console.log("Tab payment data:", paymentData);
      console.log("Current form state:", {
        customerType,
        customerForm,
        checkInDate,
        checkOutDate,
        selectedChildren: selectedChildren.length,
      });

      await submitOrder(paymentData, 12); // status 12 for bar tender reservation
      setShowTabSearchModal(false);
      setSelectedTabClient(null);
      setSelectedChildren([]);
      toast.success(
        `Items added to ${selectedTabClient.name}'s tab successfully!`,
      );
    } catch (error) {
      console.error("Error processing tab payment:", error);
      console.error("Full error details:", {
        message: error.message,
        stack: error.stack,
        paymentData,
        customerType,
        customerForm,
      });
      toast.error(
        `Failed to add items to tab: ${error.message || "Unknown error"}`,
      );
    } finally {
      setLoading(false);
    }
  };

  // Hydrate edit view from API data (GetReservations3)
  useEffect(() => {
    if (!data) return;
    try {
      const api = data || {};
      // Determine booking type
      const isCompany = Number(api.companyID ?? api.companyId ?? 0) > 0;
      // console.log("=== BOOKING TYPE DETERMINATION ===");
      // console.log("api.companyID:", api.companyID);
      // console.log("api.companyId:", api.companyId);
      // console.log("isCompany:", isCompany);
      // console.log("=====================================");
      setCustomerType(isCompany ? "company" : "individual");

      // Normalize dates
      const toDate = (d) => (typeof d === "string" ? d.split("T")[0] : d);
      setCheckInDate(toDate(api.orderDate) || null);
      setCheckOutDate(toDate(api.checkOutDate) || null);

      // Prefill customer/company details
      if (!isCompany) {
        console.log("=== HYDRATING INDIVIDUAL BOOKING ===");
        console.log("Individual customer data:", {
          customerName: api.customerName,
          customerNumber: api.customerNumber,
          phoneNumber: api.phoneNumber,
          email: api.email,
          customerID: api.customerID,
          customerId: api.customerId,
        });
        setCustomerForm((prev) => ({
          ...prev,
          customerName: api.customerName || "",
          phoneNumber: api.customerNumber || api.phoneNumber || "",
          email: api.email || "",
          isCustomerSelected: Boolean(api.customerID || api.customerId),
          customerID: api.customerID || api.customerId || null,
        }));
        if (api.customerID || api.customerId) {
          setSelectedCustomer({
            customerID: api.customerID || api.customerId,
            customerName: api.customerName || "",
            phoneNumber: api.customerNumber || api.phoneNumber || "",
            email: api.email || "",
          });
        }
      } else {
        setCompanyForm((prev) => ({
          ...prev,
          companyName: api.companyName || "",
          companyID: api.companyID || api.companyId || null,
          companyAddress: api.companyAddress || api.address || "",
          companyContact: api.companyContact || api.companyPhoneNumber || "",
          companyEmail: api.companyEmail || api.companyEmailAddress || "",
          isCompanySelected: Boolean(api.companyID || api.companyId),
        }));
      }

      // Map services to UI selections
      const rawServices =
        api.serviceTypeAndName || api.services || api.ServiceTypeAndName || [];
      if (!Array.isArray(rawServices)) return;

      // Debug: Check what keyID fields are available in raw data
      console.log(
        "Raw services from API:",
        rawServices.map((s) => ({
          keyID: s.keyID,
          keyId: s.keyId,
          orderDetailPrimaryID: s.orderDetailPrimaryID,
          orderDetailId: s.orderDetailId,
          serviceId: s.serviceId,
          serviceID: s.serviceID,
          roomId: s.roomId,
          room_id: s.room_id,
          id: s.id,
          ID: s.ID,
        })),
      );

      const toBase = (s) => {
        const typeName =
          s.service_type_name || s.serviceName || s.typeName || "";
        const rate = Number(
          s.servicePrice ?? s.rate ?? s.service_rate ?? s.price ?? 0,
        );
        const qtyRaw = Number(
          s.serviceQuantity ?? s.quantity ?? s.service_qty ?? 1,
        );
        const qty = qtyRaw > 0 ? qtyRaw : 1;

        // FIXED: Better keyId detection for existing order details
        // The keyId should be the orderDetailPrimaryID for existing services
        const keyId = Number(
          s.orderDetailPrimaryID ??
            s.orderDetailId ??
            s.keyID ??
            s.keyId ??
            s.id ??
            s.ID ??
            0,
        );

        // FIXED: Preserve original serviceId from API response (case-sensitive)
        const originalServiceId = Number(s.serviceId ?? s.serviceID ?? 0);

        // FIXED: Extract roomId properly - preserve null/0 distinction
        const roomId =
          s.roomId !== null && s.roomId !== undefined
            ? Number(s.roomId)
            : s.room_id !== null && s.room_id !== undefined
              ? Number(s.room_id)
              : 0;

        // MAP roomId to OrderDetailID - this is the actual primary key from order_details table
        const orderDetailID = roomId > 0 ? roomId : keyId;

        console.log(
          `[HYDRATION] Mapping service - originalServiceId: ${originalServiceId}, roomId: ${roomId}, keyId: ${keyId}, OrderDetailID: ${orderDetailID}, parentId: ${Number(
            s.parentId ?? s.parentID ?? 0,
          )}`,
          s,
        );

        return {
          childId: Number(s.childId ?? s.serviceTypeId ?? s.typeId ?? 0),
          typeId: Number(s.typeId ?? s.serviceTypeId ?? 0),
          typeName,
          productServiceName: s.productServiceName || s.code || typeName,
          parentId: Number(s.parentId ?? s.parentID ?? 0),
          rate: Number(rate),
          quantity: Number(qty),
          maxQuantity: qty,
          keyId,
          roomId,
          // Store the OrderDetailID mapped from roomId for existing services
          orderDetailPrimaryID: orderDetailID,
          // PRESERVE original serviceId for existing items
          originalServiceId,
          serviceId: originalServiceId, // Also store as serviceId for compatibility
        };
      };

      if (!isCompany) {
        const items = rawServices.map(toBase);
        const rooms = [];
        const others = [];
        items.forEach((it) => {
          const probe = {
            typeName: it.typeName,
            productServiceName: it.productServiceName,
          };
          if (isAccommodation(probe)) rooms.push(it);
          else others.push(it);
        });
        setSelectedRooms(rooms);
        setSelectedChildren(others);
        // Store original count for filtering
        setOriginalItemCount(rawServices.length);
        // Snapshot original individual services for diff
        setOriginalIndividualServices(
          [...rooms, ...others].map((it) => ({
            keyID: Number(it.keyId || it.keyID || 0),
            roomID: Number(it.roomId || it.roomID || 0),
            childId: Number(it.childId),
            quantity: Number(it.quantity || 1),
            rate: Number(it.rate || 0),
            typeId: Number(it.typeId || 0),
            parentId: Number(it.parentId || 0),
          })),
        );
        // Store composite keys (no reliance on server IDs) to detect additions only
        setOriginalIndividualKeyList(
          [...rooms, ...others].map(
            (it) =>
              `c:${Number(it.childId)}-t:${Number(it.typeId)}-p:${Number(
                it.parentId || 0,
              )}-r:${Number(it.rate)}`,
          ),
        );
      } else {
        // Group by sub-customer for company bookings if available
        console.log("=== HYDRATING COMPANY BOOKING ===");
        console.log("Raw services from API:", rawServices);
        const byGuest = new Map();
        rawServices.forEach((s) => {
          // Use subCustomerId as the key to properly group and preserve customerID
          const subCustomerId = Number(
            s.subCustomerId || s.sub_customer_id || 0,
          );
          const customerName =
            s.subCustomerName || s.sub_customer_name || "Guest";

          // Create a unique key that includes both ID and name for proper grouping
          const key = subCustomerId > 0 ? subCustomerId : customerName;

          // console.log("=== SUBCUSTOMER HYDRATION DEBUG ===");
          // console.log("Processing service:", s);
          // console.log("subCustomerId extracted:", subCustomerId);
          // console.log("customerName:", customerName);
          // console.log("Using key for grouping:", key);

          if (!byGuest.has(key))
            byGuest.set(key, {
              customerID: subCustomerId,
              customerName: customerName,
              customerEmail: s.subCustomerEmail || s.sub_customer_email || "",
              customerCheckIn: toDate(
                s.subCustomerCheckIn || s.sub_customer_check_in,
              ),
              customerCheckOut: toDate(
                s.subCustomerCheckOut || s.sub_customer_check_out,
              ),
              availability: null,
              services: [],
              // Capture first encountered roomId (will refine per service below)
              roomID: Number(s.roomId || s.room_id || 0),
            });
          const g = byGuest.get(key);
          const base = toBase(s);
          g.services.push({
            childId: base.childId,
            rate: base.rate,
            quantity: base.quantity,
            typeId: base.typeId,
            name: base.productServiceName || base.typeName,
            rawName: base.typeName || base.productServiceName,
            accommodation: isAccommodation({
              typeName: base.typeName,
              productServiceName: base.productServiceName,
            }),
            parentId: base.parentId || 0,
            keyId: base.keyId || 0,
            roomId: base.roomId || 0,
          });
          // If service is accommodation and has roomId, set guest roomID
          if (
            isAccommodation({
              typeName: base.typeName,
              productServiceName: base.productServiceName,
            }) &&
            (base.roomId || base.roomID)
          ) {
            g.roomID = Number(base.roomId || base.roomID);
          }
        });
        const guests = Array.from(byGuest.values());
        console.log("Processed guests:", guests);
        // Deduplicate services per guest on hydration
        guests.forEach((g) => {
          g.services = dedupeGuestServices(g.services);
        });
        console.log("Final guests after deduplication:", guests);
        setSubCustomers(guests);
        // Snapshot original guests for edit detection
        setOriginalSubCustomers(JSON.parse(JSON.stringify(guests)));
        setActiveGuestIndex(guests.length ? 0 : null);
        // Store original guest count for filtering
        setOriginalItemCount(guests.length);
        // Snapshot original company services
        setOriginalCompanyServices(
          guests.flatMap((g, gi) =>
            (g.services || []).map((s) => ({
              guestIndex: gi,
              guestName: g.customerName,
              keyID: Number(s.keyId || s.keyID || 0),
              roomID: Number(s.roomId || s.roomID || g.roomID || 0),
              childId: Number(s.childId),
              quantity: Number(s.quantity || 1),
              rate: Number(s.rate || 0),
              typeId: Number(s.typeId || 0),
              parentId: Number(s.parentId || 0),
            })),
          ),
        );
        console.log("=== END HYDRATION ===");
      }
    } catch (e) {
      // swallow hydration errors but keep UI usable
      console.error("Failed to hydrate edit view", e);
    }
  }, [data]);

  // Update quantity for a selected room (remove if <=0)
  const updateRoomQuantity = (childId, newQty) => {
    setSelectedRooms((prev) =>
      prev.flatMap((room) => {
        if (Number(room.childId) !== Number(childId)) return [room];
        if (newQty <= 0) return []; // remove room if quantity drops to 0
        return [{ ...room, quantity: Number(newQty) }];
      }),
    );
  };

  // Helper: build combined service details (rooms + selected children)
  const buildServiceDetails = () => {
    // FIXED: Helper function to determine correct service ID for backend
    const getCorrectServiceId = (item) => {
      // For existing items from API, preserve the original serviceId
      const isEditing = Boolean(data && (data.orderID || data.orderId));

      if (isEditing) {
        // Check multiple possible sources for existing serviceId
        const existingServiceId = Number(
          item.originalServiceId || item.serviceId || item.serviceID || 0,
        );

        if (existingServiceId > 0) {
          console.log(
            `[EDIT] Preserving existing serviceId ${existingServiceId} for item:`,
            item.typeName,
          );
          return existingServiceId;
        }

        // If no existing serviceId found but has keyId, this is still an existing item
        const hasKeyId = Number(item.keyId || item.keyID || 0) > 0;
        if (hasKeyId && existingServiceId === 0) {
          console.warn(
            `[EDIT] Existing item with keyId but serviceId=0, using childId:`,
            item,
          );
        }
      }

      // For new items or fallback, use childId/typeId (catalog ID)
      const catalogId = Number(item.childId || item.typeId || 0);

      if (catalogId === 0) {
        console.error(
          "Warning: Both serviceId and catalogId are 0 for item:",
          item,
        );
      }

      const logType = isEditing ? "[EDIT-NEW]" : "[CREATE]";
      console.log(
        `${logType} Using catalog ID ${catalogId} for item:`,
        item.typeName,
      );
      return catalogId;
    };

    const nightsVal = (() => {
      const n = calculateNights(checkInDate, checkOutDate);
      return n > 0 ? n : 1;
    })();
    // Safety net: ensure unique lines per childId before mapping
    const dedupeByChildId = (arr) => {
      const map = new Map();
      (arr || []).forEach((item) => {
        const key = Number(item.childId);
        map.set(key, { ...item, childId: key });
      });
      return Array.from(map.values());
    };
    const uniqueRooms = dedupeByChildId(selectedRooms);
    const uniqueChildren = dedupeByChildId(selectedChildren);
    const roomDetails = uniqueRooms.map((room) => {
      const acc = isAccommodation(room) || true; // selectedRooms are accommodations
      const detailPrice = acc
        ? room.rate * room.quantity * nightsVal
        : room.rate * room.quantity;

      // FIXED: Preserve original roomID and parentID from API
      const roomID = Number(room.roomId ?? room.roomID ?? 0);
      const parentID = Number(room.parentId ?? room.parentID ?? 0);
      const serviceID = getCorrectServiceId(room);

      console.log(
        `Building room detail - serviceID: ${serviceID}, roomID: ${roomID}, parentID: ${parentID}`,
        room,
      );

      return {
        serviceID,
        typeID: Number(room.typeId ?? room.typeID ?? 0),
        serviceQuantity: Number(room.quantity ?? 1),
        serviceRate: Number(room.rate ?? 0),
        detailPrice: Number(detailPrice),
        parentID,
        nights: acc ? nightsVal : 0,
        keyID: Number(room.keyId ?? room.keyID ?? 0),
        orderDetailPrimaryID: Number(room.orderDetailPrimaryID ?? 0),
        roomID,
      };
    });
    const childDetails = uniqueChildren.map((c) => {
      const acc = isAccommodation(c);
      const detailPrice = acc
        ? c.rate * c.quantity * nightsVal
        : c.rate * c.quantity;

      // FIXED: Preserve original roomID and parentID from API
      const roomID = Number(c.roomId ?? c.roomID ?? 0);
      const parentID = Number(c.parentId ?? c.parentID ?? 0);
      const serviceID = getCorrectServiceId(c);

      console.log(
        `Building child detail - serviceID: ${serviceID}, roomID: ${roomID}, parentID: ${parentID}`,
        c,
      );

      return {
        serviceID,
        typeID: Number(c.typeId ?? c.typeID ?? 0),
        serviceQuantity: Number(c.quantity ?? 1),
        serviceRate: Number(c.rate ?? 0),
        detailPrice: Number(detailPrice),
        parentID,
        nights: acc ? nightsVal : 0,
        keyID: Number(c.keyId ?? c.keyID ?? 0),
        orderDetailPrimaryID: Number(c.orderDetailPrimaryID ?? 0),
        roomID,
      };
    });
    const guestDetails =
      customerType === "company"
        ? subCustomers.flatMap((g, guestIndex) =>
            (g.services || [])
              .filter((s) => {
                // CRITICAL FIX: Filter out phantom/invalid services
                const serviceRate = Number(s.rate || 0);
                const serviceId = Number(s.childId || s.typeId || 0);

                // Exclude services with zero rate (phantom services)
                if (serviceRate <= 0) {
                  console.log(`Excluding phantom service with zero rate:`, s);
                  return false;
                }

                // Exclude services with invalid ID
                if (serviceId <= 0) {
                  console.log(`Excluding service with invalid ID:`, s);
                  return false;
                }

                // Only include services that have a proper name/type
                const hasName =
                  (
                    s.name ||
                    s.typeName ||
                    s.productServiceName ||
                    s.rawName ||
                    ""
                  ).trim().length > 0;
                if (!hasName) {
                  console.log(`Excluding service with no name:`, s);
                  return false;
                }

                console.log(`Including valid service:`, {
                  serviceId,
                  rate: serviceRate,
                  name: s.name || s.typeName || s.productServiceName,
                  guestName: g.customerName,
                });

                return true;
              })
              .map((s) => {
                console.log(
                  `Building service for guest ${guestIndex} (${g.customerName}):`,
                  s,
                );
                const nights = calculateNights(
                  g.customerCheckIn,
                  g.customerCheckOut,
                );
                const acc = isAccommodation(s);
                const detailPrice = acc
                  ? s.rate * s.quantity * nights
                  : s.rate * s.quantity;
                return {
                  serviceID: getCorrectServiceId(s),
                  typeID: s.typeId,
                  serviceQuantity: s.quantity,
                  serviceRate: s.rate,
                  detailPrice,
                  parentID: s.parentId || 0,
                  guestName: g.customerName,
                  nights: acc ? nights : 0,
                  keyID: Number(s.keyId ?? s.keyID ?? 0),
                  orderDetailPrimaryID: Number(s.orderDetailPrimaryID ?? 0),
                  roomID: Number(s.roomId ?? s.roomID ?? 0),
                };
              }),
          )
        : [];
    const combined = [...roomDetails, ...childDetails, ...guestDetails];
    const isEditing = Boolean(data && (data.orderID || data.orderId));
    if (!isEditing) return combined;

    // EDIT MODE (INDIVIDUAL): now send FULL list (rooms + services) with roomID so backend can diff and update.
    if (customerType === "individual")
      return combined.filter((l) => !l.guestName);

    // COMPANY: keep existing behavior (all guestDetails handled upstream by new guest filtering)
    return combined.filter((i) => i.guestName);
  };

  return (
    <div>
      {/* Full-screen submission overlay */}
      {isSubmitting && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(4, 63, 110, 0.85)",
            backdropFilter: "blur(4px)",
          }}
        >
          <style>
            {`
              .bt-loader {
                height: 60px;
                aspect-ratio: 2;
                position: relative;
              }
              .bt-loader:before {
                content: "";
                position: absolute;
                inset: 100% 75% -3px 0;
                background: #fff;
                animation: btl-0 1s linear infinite alternate;
              }
              .bt-loader:after {
                content: "";
                position: absolute;
                inset: auto 42.5% 0;
                aspect-ratio: 1;
                border-radius: 50%;
                background: #d4ac0d;
                animation:
                  btl-1 1s cubic-bezier(0,700,1,700) infinite alternate,
                  btl-2 1s linear infinite alternate;
              }
              @keyframes btl-0 {
                0%,30% { translate: 0%   -2px; rotate: 20deg }
                70%,to { translate: 300% -2px; rotate:-20deg }
              }
              @keyframes btl-1 {
                0%,2%  { bottom: 0% }
                98%,to { bottom: .1% }
              }
              @keyframes btl-2 {
                0%  { translate: -220% }
                to  { translate:  220% }
              }
            `}
          </style>
          <div className="bt-loader" style={{ marginBottom: 28 }} />
          <p
            style={{
              color: "#fff",
              fontSize: 18,
              fontWeight: 600,
              letterSpacing: 0.5,
              margin: 0,
            }}
          >
            Processing your order
          </p>
          <p
            style={{
              color: "rgba(255,255,255,0.6)",
              fontSize: 13,
              marginTop: 14,
            }}
          >
            Please wait — do not close or refresh
          </p>
        </div>
      )}
      <div className="row align-items-center justify-content-between mb-2">
        <div className="col">
          <h5 className="fw-500 text-dark"> Food & Drinks</h5>
        </div>
      </div>

      <div className="row">
        {/* Only show Product/Service Selection - remove all booking form */}
        {/* Product/Service Selection */}
        <div className="col-12">
          <div className="card mb-4">
            <div className="card-header p-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center">
                  {selectedCategory && (
                    <button
                      className="btn btn-link p-0 me-3"
                      onClick={() => {
                        setSelectedCategory(null);
                        setIsInCategoryView(false);
                      }}
                    >
                      <FaArrowLeft size={18} color="#043f6e" />
                    </button>
                  )}
                  <h5 className="mb-0">
                    {selectedCategory
                      ? `${selectedCategory}`
                      : "Select Category"}
                  </h5>
                </div>
              </div>

              {/* Commented out filter buttons since we're only showing drinks from parentId 217 */}
              {/* 
              <div className="mb-3">
                <button
                  className={`btn btn-sm mb-0 me-1 ${
                    filterType === "All" ? "btn-primary" : "active"
                  }`}
                  type="button"
                  onClick={() => setFilterType("All")}
                >
                  All
                </button>
                <button
                  className={`btn btn-sm mb-0 me-1 ${
                    filterType === "Product" ? "btn-primary" : "active"
                  }`}
                  type="button"
                  onClick={() => setFilterType("Product")}
                >
                  Product
                </button>
                <button
                  className={`btn btn-sm mb-0 me-1 ${
                    filterType === "Service" ? "btn-primary" : "active"
                  }`}
                  type="button"
                  onClick={() => setFilterType("Service")}
                >
                  Service
                </button>
              </div>
              */}
              <div className="col-md-12">
                <input
                  type="text"
                  className="form-control"
                  placeholder={
                    selectedCategory
                      ? `Search in ${selectedCategory}...`
                      : "Search  by name or description..."
                  }
                  value={sortFilter.productSearch}
                  onChange={(e) =>
                    setSortFilter({
                      ...sortFilter,
                      productSearch: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="mb-2">
              {serviceProductsApi.isError && <Error />}
              {serviceProductsApi.isLoading && <Loader height="200px" />}
              {serviceProductsApi.isSuccess && (
                <div className="px-2">
                  {/* Show categories when no specific category is selected AND no search term */}
                  {!selectedCategory && !sortFilter.productSearch
                    ? (() => {
                        // Get unique categories from filteredProducts
                        const categories = [
                          ...new Set(
                            filteredProducts.map(
                              (product) => product.productServiceName,
                            ),
                          ),
                        ];

                        return categories.length > 0 ? (
                          <div className="row g-3">
                            {categories.map((category, index) => {
                              const IconComponent = getCategoryIcon(
                                category,
                                filteredProducts,
                              );
                              return (
                                <div
                                  className="col-6 col-sm-6 col-md-4 col-lg-3"
                                  key={index}
                                >
                                  <div
                                    className="card border-0 shadow-sm cursor-pointer"
                                    style={{
                                      borderRadius: "12px",
                                      transition: "all 0.2s ease",
                                      minHeight: "150px",
                                    }}
                                    onClick={() => {
                                      setSelectedCategory(category);
                                      setIsInCategoryView(true);
                                    }}
                                  >
                                    <div className="card-body p-3 d-flex flex-column justify-content-center align-items-center text-center">
                                      <div className="mb-3">
                                        <IconComponent
                                          size={40}
                                          color="#043f6e"
                                        />
                                      </div>
                                      <h6
                                        className="card-title mb-0"
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "700",
                                          color: "#333",
                                          lineHeight: "1.3",
                                        }}
                                      >
                                        {category}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="text-center py-4">
                            <h6 className="text-muted">
                              No categories available
                            </h6>
                          </div>
                        );
                      })()
                    : /* Show items when a category is selected */
                      (() => {
                        // Extract all child items from selected category
                        const allChildItems =
                          filteredProducts?.flatMap(
                            (product) =>
                              product.childRecords?.map((child) => ({
                                ...child,
                                productServiceName: product.productServiceName,
                              })) || [],
                          ) || [];

                        return allChildItems.length > 0 ? (
                          <div className="row g-2">
                            {allChildItems.map((item, i) => {
                              const isSelected = selectedChildren.some(
                                (sel) =>
                                  sel.childId?.toString() ===
                                  item.childId?.toString(),
                              );

                              return (
                                <div
                                  className="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2"
                                  key={i}
                                >
                                  <div
                                    className={`card border-0 shadow-sm ${
                                      isSelected
                                        ? "border-2"
                                        : "border border-light"
                                    }`}
                                    style={{
                                      borderRadius: "12px !important",
                                      transition: "all 0.2s ease !important",
                                      minHeight: "160px !important",
                                      transform: isSelected
                                        ? "scale(0.98) !important"
                                        : "scale(1) !important",
                                      borderColor: isSelected
                                        ? "#cc9414 !important"
                                        : "",
                                      backgroundColor: isSelected
                                        ? "#fdf6e3 !important"
                                        : "#ffffff !important",
                                    }}
                                  >
                                    <div
                                      className="card-body p-3 d-flex flex-column justify-content-between h-100 cursor-pointer"
                                      onClick={() =>
                                        !isSelected
                                          ? handleSelectChild(item)
                                          : null
                                      }
                                    >
                                      <div className="text-center">
                                        <h6
                                          className="card-title mb-2"
                                          style={{
                                            fontSize: "13px !important",
                                            fontWeight: "700 !important",
                                            lineHeight: "1.2 !important",
                                            color: isSelected
                                              ? "#cc9414 !important"
                                              : "#333 !important",
                                            minHeight: "32px !important",
                                            display: "flex !important",
                                            alignItems: "center !important",
                                            justifyContent: "center !important",
                                          }}
                                        >
                                          {item.typeName}
                                        </h6>
                                        {item.description && (
                                          <small
                                            className={`d-block mb-2 ${
                                              isSelected ? "" : "text-muted"
                                            }`}
                                            style={{
                                              fontSize: "10px !important",
                                              lineHeight: "1.2 !important",
                                              color: isSelected
                                                ? "#b7950b !important"
                                                : "",
                                            }}
                                          >
                                            {item.description}
                                          </small>
                                        )}
                                        <span
                                          className={`fw-bold`}
                                          style={{
                                            fontSize: "14px !important",
                                            color: isSelected
                                              ? "#28a745 !important"
                                              : "#28a745 !important",
                                          }}
                                        >
                                          R {item.rate.toFixed(2)}
                                        </span>
                                      </div>

                                      {isSelected ? (
                                        <div className="mt-auto">
                                          <div className="d-flex align-items-center justify-content-center mb-2">
                                            <button
                                              className="btn btn-sm d-flex align-items-center justify-content-center"
                                              style={{
                                                width: "32px !important",
                                                height: "32px !important",
                                                backgroundColor:
                                                  "#cc9414 !important",
                                                borderColor:
                                                  "#cc9414 !important",
                                                color: "white !important",
                                                borderRadius: "6px !important",
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                const selectedItem =
                                                  selectedChildren.find(
                                                    (sel) =>
                                                      sel.childId?.toString() ===
                                                      item.childId?.toString(),
                                                  );
                                                if (
                                                  selectedItem &&
                                                  selectedItem.quantity > 1
                                                ) {
                                                  const updated =
                                                    selectedChildren.map(
                                                      (sel) =>
                                                        sel.childId?.toString() ===
                                                        item.childId?.toString()
                                                          ? {
                                                              ...sel,
                                                              quantity:
                                                                sel.quantity -
                                                                1,
                                                            }
                                                          : sel,
                                                    );
                                                  setSelectedChildren(updated);
                                                }
                                              }}
                                            >
                                              <FaMinus size={10} />
                                            </button>
                                            <span
                                              className="mx-3 fw-bold"
                                              style={{
                                                minWidth: "25px !important",
                                                textAlign: "center !important",
                                                fontSize: "16px !important",
                                                color: "#cc9414 !important",
                                              }}
                                            >
                                              {selectedChildren.find(
                                                (sel) =>
                                                  sel.childId?.toString() ===
                                                  item.childId?.toString(),
                                              )?.quantity || 1}
                                            </span>
                                            <button
                                              className="btn btn-sm d-flex align-items-center justify-content-center"
                                              style={{
                                                width: "32px !important",
                                                height: "32px !important",
                                                backgroundColor:
                                                  "#cc9414 !important",
                                                borderColor:
                                                  "#cc9414 !important",
                                                color: "white !important",
                                                borderRadius: "6px !important",
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                const updated =
                                                  selectedChildren.map((sel) =>
                                                    sel.childId?.toString() ===
                                                    item.childId?.toString()
                                                      ? {
                                                          ...sel,
                                                          quantity:
                                                            sel.quantity + 1,
                                                        }
                                                      : sel,
                                                  );
                                                setSelectedChildren(updated);
                                              }}
                                            >
                                              <FaPlus size={10} />
                                            </button>
                                          </div>
                                          <button
                                            className="btn btn-sm w-100 d-flex align-items-center justify-content-center"
                                            style={{
                                              fontSize: "11px !important",
                                              backgroundColor:
                                                "#dc3545 !important",
                                              borderColor: "#dc3545 !important",
                                              color: "white !important",
                                              borderRadius: "6px !important",
                                              gap: "4px !important",
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setSelectedChildren(
                                                selectedChildren.filter(
                                                  (sel) =>
                                                    sel.childId?.toString() !==
                                                    item.childId?.toString(),
                                                ),
                                              );
                                            }}
                                          >
                                            <FaTrash size={8} /> Remove
                                          </button>
                                        </div>
                                      ) : (
                                        <div className="mt-auto text-center">
                                          <small className="text-muted">
                                            Tap to add
                                          </small>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="text-center py-4">
                            <h6 className="text-muted">No drinks available</h6>
                          </div>
                        );
                      })()}
                </div>
              )}
            </div>

            {/* Simple Order Summary */}
            {selectedChildren.length > 0 && (
              <div className="mt-4">
                <div
                  className="card"
                  style={{ borderColor: "#d4ac0d", borderWidth: "2px" }}
                >
                  <div className="card-body p-3">
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6
                          className="mb-0 fw-bold"
                          style={{ color: "#d4ac0d" }}
                        >
                          Order Summary
                        </h6>
                        <div className="text-end">
                          <div
                            className="fs-5 fw-bold"
                            style={{ color: "#d4ac0d" }}
                          >
                            R {subtotal.toFixed(2)}
                          </div>
                          <small className="text-muted">Total Amount</small>
                        </div>
                      </div>

                      {/* Selected drinks list */}
                      <div
                        className="bg-light rounded p-2 mb-2"
                        style={{ maxHeight: "120px", overflowY: "auto" }}
                      >
                        {selectedChildren.map((item, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between align-items-center py-1"
                          >
                            <div className="flex-grow-1">
                              <small className="fw-bold text-dark">
                                {item.quantity}x {item.typeName}
                              </small>
                              <div>
                                <small className="text-muted">
                                  R {item.rate.toFixed(2)} each
                                </small>
                              </div>
                            </div>
                            <div className="text-end">
                              <small
                                className="fw-bold"
                                style={{ color: "#d4ac0d" }}
                              >
                                R {(item.quantity * item.rate).toFixed(2)}
                              </small>
                            </div>
                          </div>
                        ))}
                      </div>

                      <small className="text-muted">
                        {selectedChildren.length} drink
                        {selectedChildren.length > 1 ? "s" : ""} •
                        {selectedChildren.reduce(
                          (sum, item) => sum + (item.quantity || 1),
                          0,
                        )}{" "}
                        total quantity
                      </small>
                    </div>

                    <div className="d-grid gap-2">
                      <button
                        type="button"
                        className="btn"
                        disabled={
                          selectedChildren.length === 0 ||
                          loading ||
                          isSubmitting
                        }
                        style={{
                          backgroundColor: "#043f6e",
                          borderColor: "#043f6e",
                          color: "white",
                          fontWeight: "600",
                          fontSize: "16px",
                          padding: "12px",
                        }}
                        onClick={() => {
                          setPaymentFormModal(true);
                        }}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <RiBankCard2Fill /> Proceed to Payment
                          </>
                        )}
                      </button>

                      <button
                        type="button"
                        className="btn"
                        disabled={
                          selectedChildren.length === 0 ||
                          loading ||
                          isSubmitting
                        }
                        style={{
                          backgroundColor: "#d4ac0d",
                          borderColor: "#d4ac0d",
                          color: "white",
                          fontWeight: "600",
                          fontSize: "16px",
                          padding: "12px",
                        }}
                        onClick={handleAddToTab}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <MdLocalBar className="me-2" /> Add to Tab
                          </>
                        )}
                      </button>

                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => {
                          setSelectedChildren([]);
                        }}
                      >
                        🗑️ Clear All Items
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Payment Form Modal */}
      <Modal
        show={paymentFormModal}
        onHide={() => setPaymentFormModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Payment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddPaymentForm
            handleSubmit={handlePaymentSubmit}
            totalAmount={subtotal}
            setPaymentFormModal={setPaymentFormModal}
            data={paymentData}
          />
        </Modal.Body>
      </Modal>

      {/* Credit Limit Confirmation Modal */}
      <Modal
        show={limitModal.show}
        onHide={() => setLimitModal((m) => ({ ...m, show: false }))}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Credit Approval Required</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2">
            <p className="mb-1">
              The customer's account cannot cover this reservation.
            </p>
            <small className="text-muted d-block">
              Reason: {limitModal.reason}
            </small>
            {Number(limitModal.diff) > 0 && (
              <small className="text-muted d-block">
                Shortfall: R {Number(limitModal.diff).toFixed(2)}
              </small>
            )}
          </div>
          <p className="mb-0">
            Choose Cancel to select another payment method, or Proceed to send
            this to the Credit Manager for approval.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setLimitModal((m) => ({ ...m, show: false }));
              // Switch back to normal payment path so user can choose an alternative method
              setIsOnAccount(false);
              setPaymentFormModal(true);
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              const intent = getStoredPaymentData() || {};
              setLimitModal((m) => ({ ...m, show: false }));
              // Submit to Credit Manager with exceed flag
              const payload = {
                billToAccount: true,
                paymentType: 4,
                paidAmount: 0,
                discount: 0,
                discountType: 0,
                taxAmount: 0,
                taxPercentage: 0,
                utrNumber: "",
                notes: intent.notes || "Billed to account - credit approval",
                exceedLimitFlag: true,
              };
              submitOrder(payload, 12);
            }}
          >
            Proceed
          </button>
        </Modal.Footer>
      </Modal>

      {/* Account on Hold Modal */}
      <Modal
        show={accountHoldModal.show}
        onHide={() => setAccountHoldModal((m) => ({ ...m, show: false }))}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Account on Hold</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <p className="mb-2">
              <strong>{accountHoldModal.customerName}</strong>'s account is
              currently on hold and cannot be billed to.
            </p>
            <p className="mb-2">
              Please contact the Credit Manager to resolve this issue or choose
              an alternative payment method.
            </p>
            <div className="alert alert-warning mb-0">
              <i className="fas fa-exclamation-triangle me-2"></i>
              <strong>Note:</strong> Account payments are temporarily suspended
              for this {accountHoldModal.customerType}.
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              setAccountHoldModal((m) => ({ ...m, show: false }));
              // Switch back to normal payment path
              setIsOnAccount(false);
              setPaymentFormModal(true);
            }}
          >
            Choose Payment Method
          </button>
        </Modal.Footer>
      </Modal>

      {/* Tab Search Modal */}
      <Modal
        show={showTabSearchModal}
        onHide={() => setShowTabSearchModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <MdLocalBar className="me-2" />
            Add to Tab - Select Client
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label fw-bold">Search Client</label>
            <input
              type="text"
              className="form-control"
              placeholder="Search by name, email, phone, address, or client ID..."
              value={tabSearchTerm}
              onChange={(e) => setTabSearchTerm(e.target.value)}
              autoFocus
            />
            <small className="text-muted">
              Only clients with Account Payment type will be shown
            </small>
          </div>

          {loadingTabClients && (
            <div className="text-center py-3">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Searching...</span>
              </div>
              <p className="mt-2 text-muted">Searching clients...</p>
            </div>
          )}

          {tabSearchTerm && !loadingTabClients && tabClients.length === 0 && (
            <div className="text-center py-3">
              <p className="text-muted">
                No clients found for "{tabSearchTerm}"
              </p>
            </div>
          )}

          {tabClients.length > 0 && (
            <div className="mb-3">
              <label className="form-label fw-bold">Select Client</label>
              <div
                className="list-group"
                style={{ maxHeight: "300px", overflowY: "auto" }}
              >
                {tabClients.map((client) => (
                  <button
                    key={client.clientID}
                    type="button"
                    className={`list-group-item list-group-item-action ${
                      selectedTabClient?.clientID === client.clientID
                        ? "active"
                        : ""
                    }`}
                    onClick={() => handleTabClientSelect(client)}
                  >
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <h6 className="mb-1 fw-bold">{client.name}</h6>
                        <p className="mb-1">
                          <small>
                            <strong>ID:</strong> {client.clientID} |{" "}
                            <strong>Phone:</strong> {client.phone} |{" "}
                            <strong>Email:</strong> {client.email}
                          </small>
                        </p>
                        <small className="text-muted">{client.address}</small>
                        <div className="mt-1">
                          <span
                            className={`badge ${
                              client.creditAccStatus?.toLowerCase() === "active"
                                ? "bg-success"
                                : client.creditAccStatus?.toLowerCase() ===
                                    "on hold"
                                  ? "bg-warning text-dark"
                                  : "bg-secondary"
                            }`}
                          >
                            {client.creditAccStatus || "Unknown Status"}
                          </span>
                          {client.creditLimit && (
                            <span className="badge bg-info text-dark ms-1">
                              Credit Limit: R{client.creditLimit.toFixed(2)}
                            </span>
                          )}
                          {client.currentLimit !== undefined && (
                            <span className="badge bg-primary ms-1">
                              Available: R{client.currentLimit.toFixed(2)}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}

          {selectedTabClient && (
            <div className="alert alert-info">
              <h6 className="alert-heading">Selected Client:</h6>
              <p className="mb-0">
                <strong>{selectedTabClient.name}</strong> (ID:{" "}
                {selectedTabClient.clientID})
              </p>
              <small>
                Total Amount:{" "}
                <strong>
                  R
                  {selectedChildren
                    .reduce((sum, item) => sum + item.quantity * item.rate, 0)
                    .toFixed(2)}
                </strong>
              </small>

              {/* Quotation option */}
              <div className="form-check mt-3">
                <input
                  type="checkbox"
                  id="tabCreateQuotation"
                  className="form-check-input"
                  checked={tabCreateQuotation}
                  onChange={(e) => setTabCreateQuotation(e.target.checked)}
                />
                <label
                  htmlFor="tabCreateQuotation"
                  className="form-check-label"
                >
                  Create as Quotation / Proforma
                </label>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowTabSearchModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={!selectedTabClient || loading || isSubmitting}
            onClick={handleTabPayment}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Adding to Tab...
              </>
            ) : (
              <>
                <MdLocalBar className="me-2" />
                Add to Tab
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Tab Quotation Email Modal */}
      <Modal
        show={showTabEmailModal}
        onHide={() => setShowTabEmailModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Send Quotation / Proforma</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label fw-bold">Document Type</label>
            <select
              className="form-select"
              value={tabDocSendType}
              onChange={(e) => setTabDocSendType(e.target.value)}
            >
              <option value="proforma">Proforma Invoice</option>
              <option value="quotation">Quotation</option>
            </select>
          </div>
          <div className="mb-3">
            <label className="form-label fw-bold">Email Address *</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter recipient email"
              value={tabQuotationEmail}
              onChange={(e) => setTabQuotationEmail(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label fw-bold">CC Email (optional)</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter CC email"
              value={tabCcEmail}
              onChange={(e) => setTabCcEmail(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setShowTabEmailModal(false);
              setShowTabSearchModal(true); // go back to tab modal
            }}
          >
            Back
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={!tabQuotationEmail.trim() || loading || isSubmitting}
            onClick={async () => {
              const primary = tabQuotationEmail.trim();
              const cc = tabCcEmail.trim();
              const emailRegex = /[^@\s]+@[^@\s]+\.[^@\s]+/;
              if (!emailRegex.test(primary)) {
                toast.error("Primary email is invalid");
                return;
              }
              if (cc && !emailRegex.test(cc)) {
                toast.error("CC email is invalid");
                return;
              }

              const totalAmount = selectedChildren.reduce(
                (sum, item) => sum + item.quantity * item.rate,
                0,
              );

              const paymentData = {
                paymentType: 4,
                amount: totalAmount,
                subtotal: totalAmount,
                grossTotal: totalAmount,
                paidAmount: 0,
                discountAmount: 0,
                billToAccount: true,
                customerID: selectedTabClient?.clientID,
                customerName: selectedTabClient?.name,
                customerEmail: selectedTabClient?.email || "",
                clientType:
                  selectedTabClient?.clientType === "Customer"
                    ? "individual"
                    : selectedTabClient?.clientType?.toLowerCase() ||
                      "individual",
                clientID: selectedTabClient?.clientID,
                discount: 0,
                discountType: 0,
                taxAmount: 0,
                taxPercentage: 0,
                utrNumber: "",
                notes: "Quotation via Bar Tender tab",
                createQuotation: true,
                quotationEmail: primary,
                ccEmail: cc || "",
                documentType: tabDocSendType,
                exceedLimitFlag: false,
                Exceed_Limit: "no",
              };

              try {
                setLoading(true);
                const today = new Date().toISOString().split("T")[0];
                if (!checkInDate) setCheckInDate(today);
                if (!checkOutDate) setCheckOutDate(today);

                await submitOrder(paymentData, 11); // status 11 for quotation
                setShowTabEmailModal(false);
                setSelectedTabClient(null);
                setSelectedChildren([]);
                setTabCreateQuotation(false);
                toast.success(`Quotation sent to ${primary} successfully!`);
              } catch (error) {
                console.error("Error sending tab quotation:", error);
                toast.error(
                  `Failed to send quotation: ${error.message || "Unknown error"}`,
                );
              } finally {
                setLoading(false);
              }
            }}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Sending...
              </>
            ) : (
              `Send ${tabDocSendType === "quotation" ? "Quotation" : "Proforma"}`
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BarTender;
